import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-warining-container',
  templateUrl: './warining-container.component.html',
  styleUrls: ['./warining-container.component.scss']
})
export class WariningContainerComponent implements OnInit {
  @Input() subtitle:string;
  @Input() name:string;
  @Input() className:any;
  
    constructor() { }
  
    ngOnInit() {
    }
  
  
  }
  